export class DragSelector {
    public isDragging: boolean = false;
    private startX: number = 0;
    private startY: number = 0;
    private currentX: number = 0;
    private currentY: number = 0;
    private container: HTMLDivElement;
    private selectionBox: HTMLDivElement;
  
    constructor(container: HTMLDivElement) {
      this.container = container;
      this.selectionBox = this.container.querySelector('.drag-selector') as HTMLDivElement;
      if(!this.selectionBox)
      {
        this.selectionBox = document.createElement("div");
        this.selectionBox.classList.add("drag-selector");
        this.selectionBox.style.position = "absolute";
        this.selectionBox.style.backgroundColor = "rgba(0, 0, 255, 0.3)";
        this.selectionBox.style.border = "1px solid blue";
        this.selectionBox.style.zIndex = "10000";
        this.selectionBox.style.pointerEvents = "none";      
        this.container.appendChild(this.selectionBox);
      }
    }
  
    public handleMouseDown(e: MouseEvent, scale:[number,number] = [1,1]) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.currentX = e.clientX;
      this.currentY = e.clientY;
      this.updateSelectionBox(scale);
    }
  
    public handleMouseMove(e: MouseEvent, scale:[number,number] = [1,1]) {
      if (!this.isDragging) return;
      this.currentX = e.clientX;
      this.currentY = e.clientY;
      this.updateSelectionBox(scale);
    }
  
public getOffsetTop(element: HTMLElement): number {
    let top = 0;
    let currentElement = element;
    
    while (currentElement) {
        top += currentElement.offsetTop;
        
        // handling for scrolling of parent containers
        if (currentElement.offsetParent) {
            top -= (currentElement.offsetParent as HTMLElement).scrollTop;
        }
        // handling margins of the current element
        const style = window.getComputedStyle(currentElement);
        top += parseInt(style.marginTop) || 0;
        
        currentElement = currentElement.offsetParent as HTMLElement;
    }
    return top;
}

public getOffsetLeft(element: HTMLElement): number {
    let left = 0;
    let currentElement = element;
    
    while (currentElement) {
        left += currentElement.offsetLeft;
        
        // handling for scrolling of parent containers
        if (currentElement.offsetParent) {
            left -= (currentElement.offsetParent as HTMLElement).scrollLeft;
        }
        
        // handling margins of the current element
        const style = window.getComputedStyle(currentElement);
        left += parseInt(style.marginLeft) || 0;
        
        currentElement = currentElement.offsetParent as HTMLElement;
    }
    return left;
}

    public handleMouseUp(scale:[number,number] = [1,1]): DOMRect {
      this.isDragging = false;
      const offsetLeft = this.getOffsetLeft(this.container);
      const offsetTop = this.getOffsetTop(this.container);
      const scrollTop = this.getScrollTop(this.container);
      const scrollLeft = this.getScrollLeft(this.container);
      const sa: DOMRect = this.selectionBox.getBoundingClientRect();
      
      // Clean up the selection box
      this.selectionBox.style.width = "0px";
      this.selectionBox.style.height = "0px";
      this.selectionBox.parentElement?.removeChild(this.selectionBox);
      
      return new DOMRect((sa.left - offsetLeft + scrollLeft) / scale[0], (sa.top - offsetTop + scrollTop) / scale[1], sa.width / scale[0], sa.height / scale[1]);
    }
 
    private updateSelectionBox(scale:[number,number] = [1,1]) {
      if (!this.isDragging) return;
      
      const offsetLeft = this.getOffsetLeft(this.container);
      const offsetTop = this.getOffsetTop(this.container);
      const scrollTop = this.getScrollTop(this.container);
      const scrollLeft = this.getScrollLeft(this.container);
      const left = (Math.min(this.startX, this.currentX) - (offsetLeft) + scrollLeft) / scale[0];
      const top = (Math.min(this.startY, this.currentY) - (offsetTop) + scrollTop) / scale[1];
      const width = Math.abs(this.currentX - this.startX) / scale[0];
      const height = Math.abs(this.currentY - this.startY) / scale[1];
 
      this.selectionBox.style.left = `${left}px`;
      this.selectionBox.style.top = `${top}px`;
      this.selectionBox.style.width = `${width}px`;
      this.selectionBox.style.height = `${height}px`;
    }

    private getScrollTop(element: HTMLElement): number {  
        let elementScrollTop = element.scrollTop;
       while (element.parentElement) {
          element = element.parentElement;
          elementScrollTop += element.scrollTop;
       }
        return elementScrollTop;
    }
    private getScrollLeft(element: HTMLElement): number {
        let elementScrollLeft = element.scrollLeft;
       while (element.parentElement) {
          element = element.parentElement;
          elementScrollLeft += element.scrollLeft;
       }
        return elementScrollLeft;
    }
  }